import {memo} from "react";
import DomainStatus from "../domain-status/DomainStatus";

type Props = {
    domainId: number;
};

function MemoDomainStatus({domainId}: Props) {
    return <DomainStatus domainId={domainId} />;
}

function areEqual(prevProps: Props, nextProps: Props) {
    return prevProps.domainId === nextProps.domainId;
}

export default memo(MemoDomainStatus, areEqual);
